// src/pages/settings/SiteSelect.tsx — <select> de site groupé par client (optgroup), partagé par
// PdlForm/PceForm/EngieImportModal (3 copies quasi identiques avant factorisation).

import type { ClientRecord, SiteRecord } from "../../api/settingsApi";
import { groupSitesByClient } from "../../api/settingsApi";

export function SiteSelect({ value, onChange, sites, clients, placeholder, includeOrphans = true, disabled = false, className = "field" }: {
  value: string;
  onChange: (siteId: string) => void;
  sites: SiteRecord[];
  clients: ClientRecord[];
  placeholder: string;
  /** Sites dont le clientId ne correspond à aucun client connu — listés en vrac après les groupes
   * (comportement de PdlForm/PceForm). EngieImportModal n'en avait pas — mis à false là-bas pour
   * préserver son comportement d'origine. */
  includeOrphans?: boolean;
  disabled?: boolean;
  className?: string;
}) {
  const byClient = groupSitesByClient(sites);
  return (
    <select value={value} onChange={e => onChange(e.target.value)} className={className} disabled={disabled}>
      <option value="">{placeholder}</option>
      {clients.map(c => {
        const cs = byClient.get(c.id);
        if (!cs?.length) return null;
        return <optgroup key={c.id} label={c.name}>{cs.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}</optgroup>;
      })}
      {includeOrphans && sites.filter(s => !clients.find(c => c.id === s.clientId)).map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
    </select>
  );
}
